import { subDays, startOfDay } from "date-fns";
const TIME_FORMAT = "HH:mm";
const DATE_FORMAT = "EEEEEE dd.MM";
const MAX_CALLS_TIME_STAMP = subDays(startOfDay(/* @__PURE__ */ new Date()), 4);
var DataTestIds = /* @__PURE__ */ ((DataTestIds2) => {
  DataTestIds2["CallCardName"] = "call-card-name";
  DataTestIds2["CallCardNameList"] = "call-card-name-list";
  DataTestIds2["CallCardVoicemail"] = "call-card-voicemail-button";
  DataTestIds2["CallCardVoicemailList"] = "call-card-voicemail-available-phones";
  return DataTestIds2;
})(DataTestIds || {});
export {
  DATE_FORMAT,
  DataTestIds,
  MAX_CALLS_TIME_STAMP,
  TIME_FORMAT
};
